var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sign"},[_c('div',{ref:"btnList",staticClass:"btnList"}),_c('sign-canvas',{ref:"SignCanvas",staticClass:"sign-canvas",attrs:{"options":_vm.options},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }